import { numbersRegex, phoneRegex } from "@hilma/netina2all";
import { isMobilePhone, length } from "class-validator";
import { OpenStationDataField, OpenStationDetails, TimeRangeSection } from "../types";
import { createRules } from "../functions";

export const openStationGeneralDetails: OpenStationDetails = {
    type: 'regular',
    data: [
        {
            description: i18n => i18n.sm.address.stationName,
            id: 'stationName'
        },
        {
            description: i18n => i18n.sm.address.stationNumber,
            id: 'stationId'
        },
        {
            description: i18n => i18n.sm.address.area,
            id: 'area'
        },
        {
            description: i18n => i18n.sm.additionalDetails.accessible,
            id: 'accessible'
        },
    ]
}

export const openStationAddressDetails: OpenStationDetails = {
    title: i18n => i18n.sm.address.title,
    type: 'regular',
    additional: 'map',
    data: [
        {
            description: i18n => i18n.sm.address.city,
            id: 'city'
        },
        {
            description: i18n => i18n.sm.address.title,
            id: 'address'
        },
        {
            description: i18n => i18n.sm.address.arrivalInstructions,
            id: 'arrivalInstructions',
            isEditable: true,
            rules: createRules({ arrivalInstructions: { required: true, greaterThan: 2, smallerThan: 200 } })
        },
    ]
}

export const timeRangeSections: TimeRangeSection[] = [
    {
        title: i18n => i18n.sm.openingHours.title,
        noDaysMessage: i18n => i18n.sm.openingHours.noDaysMessage,
        type: 'opening-date'
    },
    {
        title: i18n => i18n.sm.deliveryOpeningHours.title,
        noDaysMessage: i18n => i18n.sm.deliveryOpeningHours.noDaysMessage,
        type: 'delivery-opening-date'
    }
]

export const openStationManagerDetails: OpenStationDetails = {
    title: i18n => i18n.sm.managerDetails.title,
    type: 'regular',
    data: [
        {
            description: i18n => i18n.sm.managerDetails.fullName,
            id: 'fullName'
        },
        {
            description: i18n => i18n.sm.managerDetails.email,
            id: 'email'
        },
        {
            description: i18n => i18n.sm.managerDetails.phone,
            id: 'phone'
        },
        {
            description: i18n => i18n.sm.managerDetails.additionalPhone,
            id: 'additionalPhone',
            isEditable: true,
            rules: createRules({ additionalPhone: { required: false, regex: phoneRegex, classValidator: (value: string) => value ? isMobilePhone(value, 'he-IL') && (new RegExp(/^\d+/)).test(value) && length(value, 10, 10) : true } })
        }
    ]
}

export const openStationAreaManagerDetails: OpenStationDetails = {
    title: i18n => i18n.sm.areaManagerDetails.title,
    type: 'regular',
    data: [
        {
            description: i18n => i18n.sm.areaManagerDetails.fullName,
            id: 'areaManagerFullName'
        },
        // {
        //     description: i18n => i18n.sm.areaManagerDetails.email,
        //     id: 'areaManagerEmail'
        // },
        {
            description: i18n => i18n.sm.areaManagerDetails.phone,
            id: 'areaManagerPhone'
        },
    ]
}


const link: OpenStationDataField = { description: i18n => i18n.sm.additionalDetails.link, id: 'link', isLink: true };
const purchasedKits: OpenStationDataField = { description: i18n => i18n.sm.additionalDetails.purchased, id: 'purchasedKits' };
const area: OpenStationDataField = { description: i18n => i18n.sm.address.area, id: 'area' };
const accessible: OpenStationDataField = { description: i18n => i18n.sm.additionalDetails.accessible, id: 'accessible' };
const goalKits: OpenStationDataField = {
    rules: createRules({ goalKits: { required: false, regex: numbersRegex } }),
    description: i18n => i18n.sm.additionalDetails.goalKits,
    id: 'goalKits',
    isEditable: true,
};
const maxKits: OpenStationDataField = {
    description: i18n => i18n.sm.additionalDetails.maxKits,
    id: 'maxKits',
    isEditable: true,
    rules: { maxKits: { required: true, regex: numbersRegex, classValidator: (value: any) => value < 2147483647 && value > 19, activeRegexErr: i18n => i18n.errText.intMax } },
    note: i18n => i18n.sm.additionalDetails.maxKitsNote
};

export const openStationAdditionalDetails: OpenStationDetails = {
    title: i18n => i18n.sm.additionalDetails.title,
    type: 'full-width',
    data: [link, purchasedKits, goalKits, maxKits]
}

export const openStationAdditionalDetailsMobile: OpenStationDetails = {
    title: i18n => i18n.sm.additionalDetails.title,
    type: 'regular',
    additional: 'link',
    data: [area, accessible, purchasedKits, goalKits, maxKits]
}